export const events = {
  viewGetStartedPage: 'View Get Started page',
  clickStartSetup: 'Click start setup Get Started button',
  clickLearnMore: 'Click learn more Get Started button',
  clickSkip: 'Click skip Get Started button',
  openVideoTask: 'Open video task',
}
